import React from 'react';
import PropTypes from 'prop-types';

import Styled from 'src/components/Checkbox/Checkbox.styles';

const getLabel = (label, reverse) => reverse ? (
  <span>{label}</span>
) : label;

const Checkbox = ({
  checked,
  checkmarkClassName,
  className,
  disabled,
  inline,
  label,
  reverse,
  value,
  ...rest
}) => (
  <Styled.Checkbox
    className={className}
    disabled={disabled}
    inline={inline}
    reverse={reverse}
    >
    {getLabel(label, reverse)}
    <Styled.CheckboxInputWrapper reverse={reverse}>
      <Styled.Input
        {...rest}
        checked={checked || value}
        disabled={disabled}
        type="checkbox"
      />
      <Styled.Checkmark className={'check-mark'} reverse={reverse} />
    </Styled.CheckboxInputWrapper>
  </Styled.Checkbox>
);

Checkbox.propTypes = {
  label: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  checkmarkClassName: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  reverse: PropTypes.bool,
  value: PropTypes.any,
};

Checkbox.defaultProps = {
  checked: false,
  checkmarkClassName: 'check-mark',
  className: null,
  disabled: false,
  inline: false,
  reverse: false,
  value: null,
};

export default React.memo(Checkbox);
